import React from "react";

// Styles
import TrendsViewContainer from "./TrendsView.styles";
import PowerBIDashboard from "../../../../components/Common/PowerBIDashboard";

interface TrendsViewProps {}

const TrendsView = ({}: TrendsViewProps) => {
    return (
        <TrendsViewContainer>
            <div className="iframeContainer">
                <PowerBIDashboard
                    reportId="80909569-63f0-496a-bee5-1af9c12e1859"
                    workspaceId="c9679fac-e043-4b12-b47b-d350f81543c1"
                ></PowerBIDashboard>
            </div>
        </TrendsViewContainer>
    );
};
export default TrendsView;
